import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the filter view for auto-exclusion users.
 * @extends JetView
 */
export default class FilterAutoexclusionUsersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('ID is required'), // Validation message
                },
                {
                    view: 'richselect', // Dropdown for categories
                    name: 'Categorie',
                    localId: 'categorie:combo',
                    label: "<span class='icon-category'></span>" + _('Categorías'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for user creation
                    name: 'UserCreation',
                    label: "<span class='icon-folder-add'></span>" + _('Usuario Creación'),
                    labelPosition: 'top',
                    placeholder: _('Usuario Creación'),
                    invalidMessage: _('Usuario Creación is required'), // Validation message
                },
            ],
        };

        // Center left section of the form
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for subcategories
                    name: 'SubCategory',
                    localId: 'subCategorie:combo',
                    label: "<span class='icon-subcategory'></span>" + _('Sub Categoría'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for user modified
                    name: 'UserModified',
                    label: "<span class='icon-mode_edit'></span>" + _('Usuario Modificó'),
                    labelPosition: 'top',
                    placeholder: _('Usuario Modificó'),
                    invalidMessage: _('Usuario Modificó is required'), // Validation message
                },
            ],
        };

        // Center right section of the form
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for games
                    name: 'Game',
                    localId: 'game:combo',
                    label: "<span class='icon-games'></span>" + _('Juego'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Right section of the form
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for activation status
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        // Options for activation status
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Upper section combining all parts
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key triggers this button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('autoexclusionUsers:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
